import ProjectTeamCastRequestResource from "common/resources/Project/Config/Team/Cast/ProjectTeamCastRequestResource";
import ProjectTeamCastResponseResource from "common/resources/Project/Config/Team/Cast/ProjectTeamCastResponseResource";
import { createFormData } from "utils/FormData";
import BaseProjectTeamIdApi from "./BaseProjectTeamIdApi";

export default class CastApi extends BaseProjectTeamIdApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/casts`;
	}

	/**
	 * @description Get all by project team id
	 */
	public async getAllByProjectTeamId(projectId: string, projectTeamId: string): Promise<ProjectTeamCastResponseResource[]> {
		return this.getRequest<ProjectTeamCastResponseResource[]>(this.getBaseUrl({ projectId, projectTeamId })).then((response) =>
			ProjectTeamCastResponseResource.hydrateArray(response),
		);
	}

	/**
	 * @description Get one by id
	 */
	public async getById(projectId: string, projectTeamId: string, castId: string): Promise<ProjectTeamCastResponseResource> {
		return this.getRequest<ProjectTeamCastResponseResource>(`${this.getBaseUrl({ projectId, projectTeamId })}/${castId}`).then((response) =>
			ProjectTeamCastResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Download cast image
	 */
	public async downloadImage(projectId: string, projectTeamId: string, castId: string): Promise<Blob> {
		return this.getBlobRequest(`${this.getBaseUrl({ projectId, projectTeamId })}/${castId}/image`);
	}

	/**
	 * @description Create a new cast for a project team
	 */
	public async create(projectId: string, projectTeamId: string, request: ProjectTeamCastRequestResource, image?: File): Promise<ProjectTeamCastResponseResource> {
		const formData = createFormData(request);

		if (image) formData.append("file", image);

		return this.postRequestFormdata<ProjectTeamCastResponseResource>(this.getBaseUrl({ projectId, projectTeamId }), formData).then((response) =>
			ProjectTeamCastResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Update a cast for a project team
	 */
	public async update(projectId: string, projectTeamId: string, castId: string, request: ProjectTeamCastRequestResource, image?: File): Promise<ProjectTeamCastResponseResource> {
		const formData = createFormData(request);

		if (image) formData.append("file", image);

		return this.putRequestFormdata<ProjectTeamCastResponseResource>(`${this.getBaseUrl({ projectId, projectTeamId })}/${castId}`, formData).then((response) =>
			ProjectTeamCastResponseResource.hydrate(response),
		);
	}

	/**
	 * @description Delete a cast for a project team
	 */
	public async delete(projectId: string, projectTeamId: string, castId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId, projectTeamId })}/${castId}`);
	}
}
